<template>
  <div id="app">
    <Unsubscribe v-if="config"></Unsubscribe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import loadExternalConfig from "@/api/config";
import Unsubscribe from "@/components/Unsubscribe";
import getQuerystring from "@/scripts/utils";

export default {
  name: "App",
  components: {
    Unsubscribe,
  },
  metaInfo: {
    title: "Unsubscribe promotional content",
  },
  beforeMount() {
    loadExternalConfig().then((response) => {
      if (response.status === 200) {
        let config = response.data;
        this.setLanguage(response.data.defaultLanguage);
        const queries = getQuerystring();
        if (queries.playeroriginname) {
          config.name = queries.playeroriginname;
          config.displayName = queries.playeroriginname;
          config.key = queries.playeroriginkey;
          config.playeroriginlogourl = queries.playeroriginlogourl;
        }
        this.$store.commit("setConfig", config);
        this.addExternalCSS();
      } else {
        this.$store.commit("setConfig", {
          name: "",
          key: "",
          showTwoButtons: false,
          url: "",
        });
      }
    });
  },
  computed: {
    ...mapGetters(["config"]),
  },
  watch: {
    config() {
      document.body.className += this.config.classKey || this.config.key;
      this.$store.dispatch("getTranslations");
    },
  },
  methods: {
    setLanguage(defaultLanguage) {
      const language =
        window.location.pathname.split("/")[1].toLowerCase().substring(0, 2) ||
        defaultLanguage;
      if (language && !language.startsWith("?")) {
        this.$store.commit("setLanguage", language);
      }
    },
    addExternalCSS() {
      if (this.config && this.config.cssURL && this.config.cssURL.length > 0) {
        const l = document.createElement("link");
        l.type = "text/css";
        l.rel = "stylesheet";
        l.href = this.config.cssURL;

        document.head.appendChild(l);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue